module.exports = __webpack_public_path__ + "static/media/r425.a64ad356.jpg";